export default __webpack_public_path__ + "static/media/Animals_03.87391970.png";